<template>
  <div style="padding: 20px">
<!--    搜索区-->
    <div>
      <el-button icon="Plus" type="primary" :disabled="query.cityId===''" class="handle-del mr10"
                 @click="createCardRole">新增角色
      </el-button>
      <el-input placeholder="请输入校区名字" v-model="query.areaName" style="width: 150px;margin-right: 10px"></el-input>

      <el-select style="width: 150px" v-model="query.cityId" placeholder="城市" @change="getRoleList"
                 class="handle-select mr10">
        <el-option
            v-for="(item,index) in regionList" :key="index"
            :label="item.name"
            :value="item.id"></el-option>
      </el-select>
      <el-select v-model="query.roleId" filterable placeholder="请选择" @change="getRoleSubList">
        <el-option v-for="(item,index) in cardRoleList" :key="index" :label="item.name"
                   :value="item.id"></el-option>
      </el-select>
      <el-button icon="Plus" type="primary" :disabled="query.roleId===''" class="handle-del mr10" @click="editCardRole">
        修改角色
      </el-button>
      <el-button
          type="primary"
          icon="Search"
          style="margin-left: 10px"
          @click="handleSearch">搜索可见校区
      </el-button>
    </div>
<!--可视区域表格区-->
    <el-table
        :data="cardRoleSubList"
        style="width: 100%;padding: 20px;">
      <el-table-column
          prop="id"
          label="id"
          width="60">
      </el-table-column>
      <el-table-column
          prop="nameId"
          label="区域/校区ID">
      </el-table-column>
      <el-table-column
          prop="name"
          label="区域/校区"
          width="280">
      </el-table-column>
      <el-table-column show-overflow-tooltip="true" label="校区类型" width="380">
        <template #default="scope">
          <span v-if="scope.row.nameFlag === 1">中招</span>
          <span v-if="scope.row.nameFlag === 2">少年</span>
          <span v-if="scope.row.nameFlag === 4">高考</span>
          <span v-if="scope.row.nameFlag === 5">幼儿</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="设置时间">
      </el-table-column>
    </el-table>
    <!--添加角色 弹框-->
    <el-dialog
        draggable overflow
        v-model="addRoleDialog"
        title="添加角色"
        width="1000px"
        append-to-body
    >
      <el-form :model="addRole">
        <el-row>
          <el-col :span="8">
            <el-form-item label="角色名称" label-width="100px" prop="name">
              <el-input style="width:180px;" v-model="addRole.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="自增校区" label-width="100px" prop="areaType">
              <el-select v-model="addRole.isAll" class="m-2" placeholder="Select" size="large"
                         style="width:180px;margin-right: 10px">
                <el-option :value="0" label="否"/>
                <el-option :value="1" label="是"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-for=" (item,index) in addRole.flagAreaCampus" :key="index">
          <el-row>
            <el-col :span="8">
              <el-form-item label="公司类型" label-width="100px" prop="areaType">
                <el-select v-model="item.flag" disabled
                           placeholder="类型" class="handle-select mr10" style="width:180px;">
                  <el-option label="中招体育" :value="1"></el-option>
                  <el-option label="少年" :value="2"></el-option>
                  <el-option label="高考体育" :value="4"></el-option>
                  <el-option label="幼儿" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属公司" label-width="100px" prop="areaId">
                <el-cascader
                    v-model="item.cityId"
                    style="margin-right: 10px;width: 180px;"
                    placeholder="请选择区域"
                    :options="regionList"
                    collapse-tags
                    :collapse-tags-tooltip="true"
                    @change="selectCampusList(index,$event)"
                    :props="{  value:'id',label: 'name',children: 'children',multiple: true}"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="可视校区" label-width="100px" prop="">
                <el-cascader
                    style="margin-right: 10px;width: 180px;"
                    placeholder="请选择校区"
                    v-model="item.areaId"
                    :options="item.campusList"
                    collapse-tags
                    :collapse-tags-tooltip="true"
                    @change="changeAreaList"
                    :props="{multiple: true,  value:'id',label: 'name',children: 'children'}"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>

        </el-row>

        <el-form-item label="备注说明" label-width="100px" prop="remark">
          <el-input
              v-model="addRole.remark"
              :rows="3"
              type="textarea"
              placeholder="请填写备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addRoleDialog = false">取消</el-button>
        <el-button type="primary" :loading="addRoleLoading" @click="addCardRoleFun">
          {{ addRoleLoading === true ? '请稍等...' : '添加' }}
        </el-button>
      </template>
    </el-dialog>

    <!--修改角色 弹框-->
    <el-dialog
        draggable overflow
        v-model="editRoleDialog"
        :title="'修改角色-'+query.roleId+'-'+editRoleName"
        width="1000px"
        append-to-body
        v-if="query.roleId"
    >
      <el-form :model="addRole">
        <el-row>
          <el-col :span="8">
            <el-form-item label="角色名称" label-width="100px" prop="name">
              <el-input style="width:180px;" v-model="addRole.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="自增校区" label-width="100px" prop="areaType">
              <el-select v-model="addRole.isAll" class="m-2" placeholder="Select" size="large"
                         style="width:180px;margin-right: 10px">
                <el-option :value="0" label="否"/>
                <el-option :value="1" label="是"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-for=" (item,index) in addRole.flagAreaCampus" :key="index">
          <el-row>
            <el-col :span="8">
              <el-form-item label="公司类型" label-width="100px" prop="areaType">
                <el-select v-model="item.flag" disabled
                           placeholder="类型" class="handle-select mr10" style="width:180px;">
                  <el-option label="中招体育" :value="1"></el-option>
                  <el-option label="少年" :value="2"></el-option>
                  <el-option label="高考体育" :value="4"></el-option>
                  <el-option label="幼儿" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属公司" label-width="100px" prop="areaId">
                <el-cascader
                    v-model="item.cityId"
                    style="margin-right: 10px;width: 180px;"
                    placeholder="请选择区域"
                    :options="regionList"
                    collapse-tags
                    :collapse-tags-tooltip="true"
                    @change="selectCampusList(index,$event)"
                    :props="{  value:'id',label: 'name',children: 'children',multiple: true}"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="可视校区" label-width="100px" prop="">
                <el-cascader
                    style="margin-right: 10px;width: 180px;"
                    placeholder="请选择校区"
                    v-model="item.areaId"
                    :options="item.campusList"
                    collapse-tags
                    :collapse-tags-tooltip="true"
                    @change="changeAreaList"
                    :props="{multiple: true,  value:'id',label: 'name',children: 'children'}"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>

        </el-row>

        <el-form-item label="备注说明" label-width="100px" prop="remark">
          <el-input
              v-model="addRole.remark"
              :rows="3"
              type="textarea"
              placeholder="请填写备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editRoleDialog = false">取消</el-button>
        <el-button type="primary" :loading="addRoleLoading" @click="editCardRoleFun">
          {{ addRoleLoading == true ? '请稍等...' : '修改' }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {selectAreaByExpress} from "@/api/area";
import {
  addRoleAndRoleSubset,
  editRoleAndSub,
  getRoleListByJsonItem,
  getRoleSubListByRoleIdJsonItem,
  listAreaTreeByCityPost
} from "@/api/card";

export default {
  name: "CardRole",
  data() {
    return {
      query: {
        cityId: '',//所选城市级别areaId
        areaName: '',//校区名字
        roleId: '',//所选角色ID
        pageIndex: 1,
        pageSize: 10,
      },
      roleSubjectTotal: 0,//返回此角色关联校区数据
      addRoleDialog: false,//添加角色弹框
      //新增卡片角色,和编辑卡片角色的实体
      addRole: {
        id: null,
        flagAreaCampus: [
          {
            cityId: [],//城市id
            flag: 1,
            areaId: [],//校区id
            campusList: []
          }, {
            cityId: [],//城市id
            flag: 2,
            areaId: [],//校区id
            campusList: []
          }, {
            cityId: [],//城市id
            flag: 4,
            areaId: [],//校区id
            campusList: []
          }, {
            cityId: [],//城市id
            flag: 5,
            areaId: [],//校区id
            campusList: []
          }
        ],
        name: '',
        remark: '',
        isAll: 1,
      },
      editRoleDialog: false,//修改 角色 弹框状态
      editRoleName: null,//修改 角色 名
      regionList: [],//可选城市集合
      cardRoleSubList: [],//选定角色的可视区域
    }
  },
  created() {
    //获取城市数据
    selectAreaByExpress().then(res => {
      if (res.code == 200) {
        this.regionList = res.data
      } else {
        this.$message.error("获取城市数据失败");
      }
    })

  },
  methods: {
    //选择区域
    changeAreaList(e) {
      let areaListId = [];
      e.forEach(function (item) {
        areaListId.push(...item)
      })
      this.addRole.roleSubsetIdList = areaListId
    },
    //创建卡片角色
    createCardRole(e) {
      console.log(e);
      this.addRoleDialog = true;
    },
    //修改卡片角色可视校区
    editCardRole(e) {
      console.log(e)
      this.editRoleDialog = true;
      //查找要修改的角色
      let cardRoleItem = this.cardRoleList.find(item => item.id === this.query.roleId);
      if (cardRoleItem !== undefined) {
        //名字另存下
        this.editRoleName = cardRoleItem.name;
        //放到修改实体中
        this.addRole.name = cardRoleItem.name;
        this.addRole.id = cardRoleItem.id;
      }
    },
    //搜索事件
    handleSearch(e) {
      console.log(e)
      if (this.query.roleId !== '') {
        this.getRoleSubList();
      }
    },
    //获取角色
    async getRoleList() {
      let jsonItem = {'cityId': this.query.cityId}
      await getRoleListByJsonItem(jsonItem).then(res => {
        if (res.code === 200) {
          this.cardRoleList = res.data
        }
      })
    },
    //获取角色的可视区域
    async getRoleSubList() {
      let jsonItem = {'roleId': this.query.roleId, 'areaName': this.query.areaName}
      await getRoleSubListByRoleIdJsonItem(jsonItem).then(res => {
        if (res.code === 200) {
          this.cardRoleSubList = res.data;
        }
      })
    },

//获取type
    getTypeList(commodityType) {
      if (commodityType != null) {
        commodityType.forEach(items => {
          if (items != null) {
            if (items.children != null && items.children.length > 0) {
              this.getTypeList(items.children);
            } else {
              items.children = undefined;
            }
          }
        });
        return commodityType;
      }
    },
    //添加角色的时候选择城市事件
    selectCampusList(index, item) {
      let areaFlag = this.addRole.flagAreaCampus[index].flag;
      let areaIdList = [...item.flat()]
      listAreaTreeByCityPost({areaFlag, areaIdList}).then(res => {
        if (res.code === 200) {
          this.addRole.flagAreaCampus[index].campusList = this.getTypeList(res.data);
        } else {
          this.$message.error('查询校区列表失败！')
        }
      })
    },
    //添加卡片角色
    addCardRoleFun() {
      this.addRoleLoading = true;
      let oneRole = this.addRole;
      for (const item of oneRole.flagAreaCampus) {
        item.areaId = [...item.areaId.flat()]
        item.cityId = [...item.cityId.flat()]
      }

      addRoleAndRoleSubset(oneRole).then(res => {
        this.addRoleLoading = false;
        if (res.code === 200) {
          this.$message.success('添加成功')
          this.addRoleDialog = false
          this.getRoleList(this.areaId)
        } else {
          this.$message.error('添加失败')
        }
      })
    },
    //修改卡片角色-覆盖原有增加区域
    editCardRoleFun() {
      this.addRoleLoading = true;
      let oneRole = this.addRole;
      for (const item of oneRole.flagAreaCampus) {
        item.areaId = [...item.areaId.flat()]
        item.cityId = [...item.cityId.flat()]
      }
      //执行卡片角色的可视区域的修改
      editRoleAndSub(oneRole).then(res => {
        this.addRoleLoading = false;
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.editRoleDialog = false
          this.getRoleList(this.areaId)
        } else {
          this.$message.error('修改失败')
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
